import React from "react";

export default React.forwardRef(({ children, classNames = "" }, ref) => {
  return (
    <div ref={ref} className={classNames} tabIndex="-1">
      {children}
    </div>
  );
});
